import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { VIEW_ORDER } from "../../../../services/ApiCalls";
import { useParams } from "react-router-dom";
import { catchAsync } from "../../../../utilities/utilities";
import { checkResponse } from "../../../../utilities/utilities";
import Loader from "../../../../components/Common/Loader";
import moment from "moment/moment";

const OrderDetail = () => {
  const [loader, setLoader] = useState(false);
  const [userDetails, setUserUserDetails] = useState();
  const { id } = useParams();
  // console.log(id , "chkid");
  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await VIEW_ORDER(id);
    console.log(res, "chkres");
    checkResponse({ res, setData: setUserUserDetails, setLoader });
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  return (
    <>
      {loader && <Loader />}
      <section className="detail position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to="/order-management"
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#1E232C"
                      stroke="#1E232C"
                      stroke-width="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                  Appointment Detail
                </h4>
              </div>
            </Col>

            <Col lg="6" className="my-2">
              <label
                htmlFor=""
                style={{ fontSize: "1.3rem", fontWeight: "bold" }}
                className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
              >
                Details
              </label>
              <div
                className="cardCstm px-lg-4 px-3 py-2 rounded"
                style={{ background: "#eee" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Service:</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      {userDetails?.categoryId?.catName}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Booking Date:</p>
                    <p className="m-0 fw-normaltext-muted w-75">
                      {moment(userDetails?.scheduled_utc).format("DD-MM-YYYY")}
                    </p>
                  </li>

                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Slot:</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      {userDetails?.slots.map(
                        (s) =>
                          `${moment()
                            .startOf("day")
                            .add(s.startTime, "minutes")
                            .format("HH:mm")} - ${moment()
                            .startOf("day")
                            .add(s.endTime, "minutes")
                            .format("HH:mm")}`
                      )}
                    </p>
                  </li>
                  {userDetails?.orderStatus === "completed" && (
                    <li className="py-2 d-flex align-items-start">
                      <p className="m-0 fw-sbold  w-25">Duration:</p>
                      <p className="m-0 fw-normal text-muted w-75">
                        {userDetails?.duration || "1 hour"}
                      </p>
                    </li>
                  )}

                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Status:</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      {userDetails?.orderStatus}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <label
                htmlFor=""
                style={{ fontSize: "1.3rem", fontWeight: "bold" }}
                className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
              >
                Payment Details
              </label>
              <div
                className="cardCstm px-lg-4 px-3 py-2 rounded"
                style={{ background: "#eee" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Total Price:</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      ${userDetails?.orderTotal}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Payment Mode:</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      {userDetails?.paymentMethod}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Payment Status:</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      {userDetails?.paymentStatus}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="6" className="my-2">
              <label
                htmlFor=""
                style={{ fontSize: "1.3rem", fontWeight: "bold" }}
                className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
              >
                User Details
              </label>
              <div
                className="cardCstm px-lg-4 px-3 py-2 rounded"
                style={{ background: "#eee" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Name</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      {userDetails?.user?.fname +
                        " " +
                        userDetails?.user?.lname}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Phone Number:</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      {userDetails?.user?.countryCode +
                        " " +
                        userDetails?.user?.mobileNumber}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Address:</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      {userDetails?.user?.address ||
                        "3981 Ranchview Dr. Richardson, California"}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <label
                htmlFor=""
                style={{ fontSize: "1.3rem", fontWeight: "bold" }}
                className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
              >
                Therapist Details
              </label>
              <div
                className="cardCstm px-lg-4 px-3 py-2 rounded"
                style={{ background: "#eee" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Name:</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      {userDetails?.vendor?.fname +
                        " " +
                        userDetails?.vendor?.lname}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Email:</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      {userDetails?.vendor?.email}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start">
                    <p className="m-0 fw-sbold  w-25">Phone Number:</p>
                    <p className="m-0 fw-normal text-muted w-75">
                      {userDetails?.vendor?.countryCode +
                        " " +
                        userDetails?.vendor?.mobileNumber}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default OrderDetail;
